import React from "react";
import SectionHeader from "../../utilis/SectionHeader";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaQuoteLeft } from "react-icons/fa";

import "swiper/css";
import { Autoplay } from "swiper/modules";

const TestmonialSection = () => {
  const content = [
    {
      img: "/image/review-section/client-1.jpg",
      title: "Jim Morison",
      subTitle: "Director , BAT ",
      content:
        "Lorem ipsum dolor sit amet adip elitions repellat tetur delni vel quam aliq earum explibo dolor eme fugiat enim illumon.",
    },
    {
      img: "/image/review-section/client-2.jpg",
      title: "Chris Haris",
      subTitle: "Frontend Developer ",
      content:
        "Lorem ipsum dolor sit amet adip elitions repellat tetur delni vel quam aliq earum explibo dolor eme fugiat enim illumon.",
    },
    {
      img: "/image/review-section/client-3.jpg",
      title: "Thomas Gerg",
      subTitle: "Digital Marketer ",
      content:
        "Lorem ipsum dolor sit amet adip elitions repellat tetur delni vel quam aliq earum explibo dolor eme fugiat enim illumon.",
    },
    {
      img: "/image/review-section/client-4.jpg",
      title: "Alex Cruis",
      subTitle: "Graphic Designer ",
      content:
        "Lorem ipsum dolor sit amet adip elitions repellat tetur delni vel quam aliq earum explibo dolor eme fugiat enim illumon.",
    },
    {
      img: "/image/review-section/client-5.jpg",
      title: "Tom Chris",
      subTitle: "Fullstack Developer ",
      content:
        "Lorem ipsum dolor sit amet adip elitions repellat tetur delni vel quam aliq earum explibo dolor eme fugiat enim illumon.",
    },
  ];

  return (
    <div className="review_section section-padding">
      <div className="container">
        {/* HEADING SECTION */}
        <div className="row padding-bottom">
          <div className="col-lg-6 col-sm-10 mx-auto" data-aos="zoom-in">
            <SectionHeader
              subTitle="OUR REVIEWS"
              title="More Than 20,000+ Happy Customers Trust Our Services"
            />
          </div>
        </div>
        {/* CONTENT SECTION */}
        <div className="row">
          <Swiper
            slidesPerView={3}
            spaceBetween={20}
            navigation={true}
            grabCursor={true}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              572: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
            autoplay={{
              delay: 1500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className="mySwiper"
          >
            {content.map((element, index) => {
              return (
                <SwiperSlide key={index} className="my-5">
                  <div className="review_card transition index-1 position-relative bg-white rounded-4 p-lg-5 p-4 shadow-sm overflow-hidden" data-aos='fade-up'>
                    <div className="review_header d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <img
                          src={element.img}
                          className="img-fluid review_img"
                          style={{
                            width: "6rem",
                            height: "6rem",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                          alt=""
                        />
                        <div className="review_title ms-3">
                          <h5 className="  text-black transition fw-800 text-capitalize">
                            {element.title}
                          </h5>
                          <p className="text-color transition mb-0 review_subtitle">{element.subTitle}</p>
                        </div>
                      </div>
                      <div className="review_icon">
                        <FaQuoteLeft />
                      </div>
                    </div>
                    <div className="review_body mt-sm-5 mt-4">
                        <p className="text-color text-justify-left transition review_content"> {element.content}</p>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default TestmonialSection;
